import { FormControlLabel, styled } from "@mui/material";
import { Input } from "../../../../../../../../components/Form";

import GenericModal from "../../../../../../../../components/Generic/Modal";

export const Modal = styled(GenericModal)(() => ({
  maxWidth: "610px",
}));

export const RadioLabel = styled(FormControlLabel)(() => ({
  "& .MuiFormControlLabel-label": {
    fontFamily: "Manrope, sans-serif",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#465869",
  },
}));

export const Subtitle = styled("span")(() => ({
  fontFamily: "Manrope, sans-serif",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  color: "#465869",
}));

export const NumberInput = styled(Input)(() => ({
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
}));
